import { put, select } from 'redux-saga/effects';
import { pageContext } from 'ctm-util-functions';
import { locationQuerySelector } from 'ctm-selectors';
import { getAppState } from 'ctm-app/client/sagas/state_selectors';

/**
 * Generator/Saga to handle the action when user do the manual look up, a sequence of events will happen:
 * 1). Set the look up data to payload
 * 2). If the response data only have one item (e.g one car model to select), we then
 *      a). Set the item as the selected item in form state
 *      b). validate and progress the journey
 * @param {Object} action - 'SET_MANUAL_LOOKUP_DATA' action, include the identifier to set to the state
 */
const setManualLookupData = function* (action) {
    const { identifier, payload } = action;
    yield put({ type: 'SET_MANUAL_LOOKUP_PAYLOAD', identifier, payload });

    const queries = yield select(locationQuerySelector);
    const formIdentifier = _getFormIdentifier(identifier);
    const stateKey = 'vertical.quote';
    const  browserHistory = pageContext.getProps().browserHistory;

    if (Array.isArray(payload) && payload.length === 1 && queries.get('isEdit') !== 'true' && browserHistory.action !== 'POP') {
        if (formIdentifier === 'series') {
            // The last step of the car manual lookup, instead of just set one value, we finalise the manual lookup
            yield put({ type: 'FINALISE_MANUAL_LOOKUP', value: payload[0].redbookCode });
        } else {
            yield put({ type: 'SET_VEHICLE_INDIVIDUAL_FORM_DATA', identifier: formIdentifier, value: payload[0].code, stateKey });
        }
        // Prepare next page url to progress
        const pageSchemaModel = pageContext.getProps().models.pageSchemaModel;
        const pageName = `car_${formIdentifier}`;
        const path = pageSchemaModel.getPathForPageName(pageName);
        const redirectResponse = pageSchemaModel.getNextPageUrl({ path });
        yield put({ type: 'VALIDATE_AND_PROGRESS', pageName, apiSchema: { redirectResponse }, stateKey });
    } else {
        // If having more than one item, remove the pleaseWait screen and show the step as normal
        yield put({ type: 'SET_PAGE_VALUE', identifier: 'showPleaseWait', value: false });

        const appState = yield select(getAppState);
        const pageState = appState && JSON.parse(JSON.stringify(appState));

        if (pageState.page.lastViewedPage === 'confirmation') {
            yield put({ type: 'SET_PAGE_VALUE', identifier: 'showPleaseWait', value: true });
        }
    }
};

/**
 * Car specific string replace util to get the identifier for vehicle in form by remove the 's' or 'ies'
 * @example 'bodies' -> 'body', 'makes' -> 'make'
 * @param {String} identifier - the id string passed from schema
 * @returns {String} new id to be used as key path in state
 * @private
 */
export const _getFormIdentifier = (identifier) => {
    if (identifier === 'series') {
        return identifier;
    }
    if (identifier.endsWith('ies')) {
        return identifier.replace('ies', 'y'); // bodies => body
    }
    if (identifier.endsWith('s')) {
        return identifier.slice(0, -1); // years => year
    }
    return identifier;
};

export default ['SET_MANUAL_LOOKUP_DATA', setManualLookupData];
